export interface CIState {
  indexId: any;
  chartData: any;
}

export enum CIActionEnum {
  SET_INDEX_ID = "SET_INDEX_ID",
  SET_CHART_DATA_TYPE = "SET_CHART_DATA_TYPE",
}

export interface SetIndexIdAction {
  type: CIActionEnum.SET_INDEX_ID;
  payload: any;
}

export interface SetChartDataAction {
  type: CIActionEnum.SET_CHART_DATA_TYPE;
  payload: any;
}

export type CIAction = SetIndexIdAction | SetChartDataAction;
